// 头部公共

import { useState, useEffect } from 'react'
import { message, Form, Input, Button, Modal, Carousel, Dropdown, Drawer, Popover } from 'antd'
import fun from '../../common/common_fun'
import url from '../../common/url_config'
import { UserOutlined, LockOutlined, SearchOutlined, UnorderedListOutlined, DownOutlined, ExportOutlined, LoadingOutlined } from '@ant-design/icons';
import cookie, { load } from 'react-cookies'
import logo_mini from '../../img/logo_mini.png'
import common_data from '../../common/common_data';
import huijv from './../../common/huijv'

function App(props: any) {
  let [open, setOpen] = useState(false)
  let [visible_search, set_visible_search] = useState(false)
  let [key_words, set_key_words] = useState('')//关键词
  let [loading, set_loading] = useState(false)//加载中
  let [search_res_set, set_search_res_set] = useState({ rows_name: [], rows_cpu_family: [], rows_product_category: [] })//搜索结果
  let [search_mention, set_search_mention] = useState('')//搜索提示
  let [current_language_ch, set_current_language_ch] = useState(window.location.href.indexOf('?lan=en') === -1)//当前语言是否中文


  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const set_language_fun = (lang: string) => {
    if (lang === cookie.load('language')) {//语言不变
      window.location.reload()
    } else {
      cookie.save('has_show_notices', '', { path: '/' })
      cookie.save('language', lang, { path: '/' })

      setTimeout(() => {
        let temp_url = window.location.href
        if (lang === 'Chinese') {//切换为中文
          window.location.href = temp_url.replace('?lan=en', '')
        } else {//切换为英文
          if (temp_url.indexOf('?lan=en') > -1) {//当前已经是英文
            window.location.reload()
          } else {//当前是中文
            if (temp_url.indexOf('#') > -1) {//若有锚文本
              window.location.href = temp_url.split('#')[0] + '?lan=en' + '#' + temp_url.split('#')[1]
            } else {//无锚文本
              window.location.href = temp_url + '?lan=en'
            }
          }
        }
      }, 200)
    }
  }

  let nav_set = [
    {
      name_ch: '硬件',
      name_en: 'HARDWARE',
      href: '/product/overview',
    },
    {
      name_ch: '软件',
      name_en: 'SOFTWARE',
      href: '/software',
    },
    {
      name_ch: '系统方案',
      name_en: 'SOLUTION',
      href: '/solution',
    },
    {
      name_ch: '应用范例',
      name_en: 'USER GUIDE',
      href: '/use-case',
    },
    {
      name_ch: '智能车大赛',
      name_en: 'SMART CAR RACE',
      href: '/smartcar-vision',
    },
    {
      name_ch: '技术支持',
      name_en: 'SUPPORT',
      href: '/support',
    },
    {
      name_ch: '学习园地',
      name_en: 'LEARNING',
      href: '/learning-resources',
      is_developing: true,
    },
    {
      name_ch: '关于我们',
      name_en: 'ABOUT US',
      href: '/about-us',
      is_developing: true,
    },
    {
      name_ch: '恩智浦官网',
      name_en: 'GO TO NXP.COM',
      href: current_language_ch ? 'https://www.nxp.com.cn/' : 'https://www.nxp.com/',
      icon: <ExportOutlined />,
      target: '_blank',
    },
  ]

  let nav_set_en = [
    {
      name_ch: '硬件',
      name_en: 'HARDWARE',
      href: '/product/overview',
    },
    {
      name_ch: '软件',
      name_en: 'SOFTWARE',
      href: '/software',
    },
    {
      name_ch: '系统方案',
      name_en: 'SOLUTION',
      href: '/solution',
    },
    {
      name_ch: '应用范例',
      name_en: 'USER GUIDE',
      href: '/use-case',
    },
    // {
    //   name_ch: '智能车大赛',
    //   name_en: 'SMART CAR RACE',
    //   href: '/smartcar-vision',
    // },
    {
      name_ch: '技术支持',
      name_en: 'SUPPORT',
      href: '/support',
    },
    // {
    //   name_ch: '学习园地',
    //   name_en: 'LEARNING',
    //   href: '/learning-resources',
    //   is_developing: true,
    // },
    // {
    //   name_ch: '关于我们',
    //   name_en: 'ABOUT US',
    //   href: '/about-us',
    //   is_developing: true,
    // },
    // {
    //   name_ch: '恩智浦官网',
    //   name_en: 'GO TO NXP.COM',
    //   href: current_language_ch ? 'https://www.nxp.com.cn/' : 'https://www.nxp.com/',
    //   icon: <ExportOutlined />,
    //   target: '_blank',
    // },
  ]

  // 搜索事件
  const handleSearchValue = huijv.useDebounce((e: any) => { // 获取input的值
    const value = e.target.value
    if (value) {
      console.log('搜索关键词', value)
      set_loading(true)
      fun['post_data'](url + 'search_evk_boards', { key_word: value }).then(res => {
        if (res.status) {
          console.log('EVK搜索结果', res.result)
          set_search_res_set(res.result)
          if (res.result.rows_name.length + res.result.rows_cpu_family.length + res.result.rows_product_category.length === 0) {
            set_search_mention((current_language_ch ? '无搜索结果' : 'No results for ') + '"' + value + '"')
          }
        } else {
          message.error(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
        }
        set_loading(false)
      })
    }
  }, 500)

  // 搜索事件（荟聚上报）
  const handleSearchValueHuijv = huijv.useDebounce((e: any) => { // 获取input的值
    const value = e.target.value
    if (value) {
      huijv.c_cloud_lab_website_search(value, '')
    }
  }, 1500)

  useEffect(() => {
    console.log('导航页获取login_username', cookie.load('login_username'))
    // setTimeout(() => {
    //   let temp = document.getElementsByClassName('page_top_nav_box')
    //   console.log(temp[0])
    // }, 1000 * 3)
  }, [])

  return (<>
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1000, backgroundColor: 'rgba(245,245,245,0.95)', }}>
      <div className='main_index_show' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 10, paddingTop: 10, borderBottom: '1px solid #b3b3b3' }}>
        {/* 搜索遮罩 */}
        <Modal width={500} destroyOnClose style={{ top: 10 }} visible={visible_search} footer={false} onCancel={() => { set_visible_search(false) }}>
          <div>
            <Input addonBefore={<span><SearchOutlined /> {current_language_ch ? '搜索EVK' : 'Search EVK'}</span>} allowClear autoFocus value={key_words} onChange={(e: any) => {
              set_key_words(e.target.value)
              handleSearchValue(e)
              handleSearchValueHuijv(e)
              set_search_mention('')
            }} placeholder={current_language_ch ? '开发板名称/CPU/系列名称' : 'Board Name / CPU / Series Name'} style={{ width: '95%' }} />
          </div>
          {/* 搜索结果 */}
          <div style={{ marginTop: 10 }}>
            {loading && <div style={{ textAlign: 'center' }}><LoadingOutlined /></div>}
            <div>{search_mention}</div>
            <div className='search_res_a_box' style={{ maxHeight: 400, minHeight: 50, overflowY: 'auto' }}>
              {/* 板子名称 */}
              {search_res_set.rows_name.map((item: any, index: number) => <a href={'/product-' + common_data.url_board_match_set(item.product_line, false) + '/' + item.format_url_board_product_category + '/' + item.format_url_board_cpu_family + (current_language_ch ? '' : '?lan=en')} key={index}>{item.type}</a>)}
              {/* cpu_family */}
              {search_res_set.rows_cpu_family.map((item: any, index: number) => <a href={'/product-' + common_data.url_board_match_set(item.product_line, false) + '/' + item.format_url_board_product_category + '/' + item.format_url_board_cpu_family + (current_language_ch ? '' : '?lan=en')} key={index}>{item.cpu_family}</a>)}
              {/* product_category */}
              {search_res_set.rows_product_category.map((item: any, index: number) => <a href={'/product-' + common_data.url_board_match_set(item.product_line, false) + '/' + item.format_url_board_product_category + (current_language_ch ? '' : '?lan=en')} key={index}>{current_language_ch ? item.product_category_cn : item.product_category}</a>)}
            </div>
          </div>
        </Modal>

        <div className='page_top_nav_box' style={{ marginLeft: '3%', display: 'flex', alignItems: 'center' }}>
          {/* LOGO */}
          <span style={{ fontSize: 20, display: 'flex', alignItems: 'center' }}>
            <a title='aiotcloud.nxp.com.cn' target={'_blank'} href='https://www.nxp.com.cn/'><img style={common_data.isMobile ? { width: 54, height: 24, } : { width: 78, height: 35, }} src={logo_mini} /></a>
            <div className='logo_right' style={{ marginLeft: 10, color: '#64798A', borderLeft: '2px solid #9aa8b1', paddingLeft: 10, lineHeight: '35px' }}><a style={{ color: '#64798A', }} href={current_language_ch ? '/' : '/?lan=en'}>CLOUD LAB</a></div>
          </span>

          {/* PC导航 */}
          <div className={current_language_ch ? 'pc_nav' : 'pc_nav_en'} style={{ marginLeft: 15 }}>
            {[...current_language_ch ? nav_set : nav_set_en].map((item: any, index: number) => <a
              target={item.target || '_self'}
              className={item.is_developing ? 'top_nav_a_tag_developing' : 'top_nav_a_tag'}
              style={{ margin: '0 10px', fontWeight: 'bold', fontSize: 14 }}
              href={item.is_developing ? '#' : (item.href + (current_language_ch ? '' : '?lan=en'))}
              title={current_language_ch ? (item.is_developing ? '功能开发中' : item.name_ch) : (item.is_developing ? 'The function is under developing' : item.name_en)}
              key={index}>{current_language_ch ? item.name_ch : item.name_en}{(item.icon) && <span style={{ fontWeight: 'bold', marginLeft: 3, fontSize: 15 }}>{item.icon}</span>}</a>)}
          </div>

          {/* 手机导航展开收缩按钮 */}
          <div className={current_language_ch ? 'mobile_nav' : 'mobile_nav_en'} style={{ marginLeft: 15, marginTop: 4 }}>
            <UnorderedListOutlined style={{ fontSize: 20 }} onClick={() => showDrawer()} />
          </div>

          {/* 手机导航 */}
          <Drawer title={<a style={{ color: '#64798A' }} href={current_language_ch ? '/' : '/?lan=en'}>CLOUD LAB</a>} placement="left" visible={open} onClose={() => onClose()}>
            <div className='main_index_show'>
              {nav_set.map((item: any, index: number) => <a target={item.target || '_self'} style={{ margin: '0 10px', fontWeight: 'bold', display: 'block', marginBottom: 20 }} href={item.is_developing ? '#' : (item.href + (current_language_ch ? '' : '?lan=en'))} key={index}>{current_language_ch ? item.name_ch : item.name_en}{(item.icon) && <span style={{ fontWeight: 'bold', marginLeft: 3, fontSize: 15 }}>{item.icon}</span>}</a>)}
            </div>
          </Drawer>
        </div>

        {/* 登录/我的 */}
        <div style={{ marginRight: '3%', fontSize: 14 }}>
          {/* 搜索框 */}
          <span className='search_box_nav' onClick={() => {
            set_visible_search(true)
            set_key_words('')
            set_search_res_set({ rows_name: [], rows_cpu_family: [], rows_product_category: [] })
            set_loading(false)
            set_search_mention('')
          }} style={{ color: '#525252', cursor: 'pointer', }}><SearchOutlined /><span className='search_box_nav_span'> {current_language_ch ? '搜索' : 'Search'}</span></span>
          {/* 我的 */}
          {cookie.load('login_username') ? <Popover trigger="click" title={null} placement='bottom' content={<div>
            <h3><span><b>{cookie.load('login_username')}</b> {current_language_ch ? '您好' : 'WELCOME'}</span></h3>
            <h3><a style={{}} href={'/my' + (current_language_ch ? '' : '?lan=en')}>{current_language_ch ? '我的预定' : 'My Books'}</a></h3>
            <h3 onClick={() => {
              let is_confirm = window.confirm(current_language_ch ? '确定退出登录？' : 'Confirm logout?')
              if (!is_confirm) {
                return
              }
              cookie.remove('login_role',)
              cookie.save('login_username', '', { path: '/' })
              cookie.remove('session_key')

              fun['post_data'](url + 'admin_logout').then(res => {
                setTimeout(() => {
                  if (current_language_ch) {
                    window.location.href = 'https://www.nxp.com.cn/security/logout?service=https://aiotcloud.nxp.com.cn'
                  } else {
                    window.location.href = 'https://www.nxp.com/security/logout?service=https://aiotcloud.nxp.com.cn'
                  }
                }, 1000)
              })
            }} style={{ cursor: 'pointer' }}>{current_language_ch ? '退出登录' : 'Log Out'}</h3>
          </div>}>
            <span style={{ color: '#215bd6', cursor: 'pointer', marginRight: 15 }}>{current_language_ch ? '我的恩智浦' : (common_data.isMobile ? 'Account' : 'My NXP Account')}<DownOutlined style={{ marginLeft: 3, fontSize: 13 }} /></span>
          </Popover> : <span onClick={() => fun.check_login()} style={{ color: '#215bd6', cursor: 'pointer', marginRight: 15 }}>{current_language_ch ? '登录 / 注册' : 'Sign In / Register'}</span>}

          {/* 语言切换 */}
          <Popover trigger="click" title={null} placement='bottom' content={<div>
            <h3 onClick={() => set_language_fun('English')} style={{ cursor: 'pointer' }}>English</h3>
            <h3 onClick={() => set_language_fun('Chinese')} style={{ cursor: 'pointer' }}>中文 | Chinese</h3>
          </div>}>
            <span style={{ color: '#20272d', cursor: 'pointer' }}>{current_language_ch ? '语言' : 'LANGUAGE'}<DownOutlined style={{ marginLeft: 3, fontSize: 13 }} /></span>
          </Popover>
        </div>
      </div>
    </div>
    <div style={{ height: 56 }}></div>
  </>
  )
}

export default App